import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
import 'github-markdown-css';
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    ol: "ol",
    p: "p",
    pre: "pre",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Markdown 表格转换工具"
    }), "\n", _jsx(_components.h2, {
      children: "功能介绍"
    }), "\n", _jsx(_components.p, {
      children: "这是一个支持 Markdown 表格、CSV 和 JSON 格式互相转换的在线工具。无论您使用哪种格式的表格数据，都可以轻松地转换为其他格式。"
    }), "\n", _jsx(_components.h2, {
      children: "支持的格式"
    }), "\n", _jsx(_components.h3, {
      children: "Markdown 表格"
    }), "\n", _jsxs(_components.p, {
      children: ["Markdown 表格是一种使用 ", _jsx(_components.code, {
        children: "|"
      }), " 和 ", _jsx(_components.code, {
        children: "-"
      }), " 符号来创建表格的文本格式，广泛用于 Markdown 文档中。"]
    }), "\n", _jsx(_components.p, {
      children: "例如："
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-markdown",
        children: "| 姓名 | 年龄 | 城市 |\n| --- | --- | --- |\n| 张三 | 28 | 北京 |\n| 李四 | 32 | 上海 |\n| 王五 | 25 | 广州 |\n"
      })
    }), "\n", _jsx(_components.h3, {
      children: "CSV (逗号分隔值)"
    }), "\n", _jsx(_components.p, {
      children: "CSV 是一种使用逗号分隔值的文本格式，可以被 Excel 等电子表格软件直接打开。"
    }), "\n", _jsx(_components.p, {
      children: "例如："
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-csv",
        children: "姓名,年龄,城市\n张三,28,北京\n李四,32,上海\n王五,25,广州\n"
      })
    }), "\n", _jsx(_components.h3, {
      children: "JSON (JavaScript 对象表示法)"
    }), "\n", _jsx(_components.p, {
      children: "JSON 是一种轻量级的数据交换格式，被广泛应用于 Web 应用程序中。本工具支持两种 JSON 格式："
    }), "\n", _jsx(_components.h4, {
      children: "对象数组格式"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-json",
        children: "[\n  {\n    \"姓名\": \"张三\",\n    \"年龄\": \"28\",\n    \"城市\": \"北京\"\n  },\n  {\n    \"姓名\": \"李四\",\n    \"年龄\": \"32\",\n    \"城市\": \"上海\"\n  },\n  {\n    \"姓名\": \"王五\",\n    \"年龄\": \"25\",\n    \"城市\": \"广州\"\n  }\n]\n"
      })
    }), "\n", _jsx(_components.h4, {
      children: "二维数组格式"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-json",
        children: "[\n  [\"姓名\", \"年龄\", \"城市\"],\n  [\"张三\", \"28\", \"北京\"],\n  [\"李四\", \"32\", \"上海\"],\n  [\"王五\", \"25\", \"广州\"]\n]\n"
      })
    }), "\n", _jsx(_components.h2, {
      children: "使用说明"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "在左侧输入框中输入您的表格数据"
      }), "\n", _jsx(_components.li, {
        children: "选择输入格式（Markdown、CSV 或 JSON）"
      }), "\n", _jsx(_components.li, {
        children: "选择期望的输出格式"
      }), "\n", _jsx(_components.li, {
        children: "如果选择 JSON 输出格式，可以进一步选择 JSON 的具体格式（对象数组或二维数组）"
      }), "\n", _jsx(_components.li, {
        children: "右侧输出框将显示转换后的结果"
      }), "\n", _jsx(_components.li, {
        children: "您可以直接复制结果或下载为文件"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "注意事项"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "输入的数据必须符合所选格式的语法要求"
      }), "\n", _jsx(_components.li, {
        children: "CSV 格式处理较为简单，不支持带引号的复杂 CSV"
      }), "\n", _jsx(_components.li, {
        children: "表格的第一行会被视为表头"
      }), "\n", _jsx(_components.li, {
        children: "JSON 格式需要符合有效的 JSON 语法"
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
